import { render, staticRenderFns } from "./GuestIncomeView.vue?vue&type=template&id=2e70b677"
import script from "./GuestIncomeView.vue?vue&type=script&lang=js"
export * from "./GuestIncomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports